import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { Principal } from '../';
import { StateStorageService } from './state-storage.service';

@Injectable()
export class UserRouteAccessService implements CanActivate {

    constructor(private router: Router,
        private principal: Principal,
        private stateStorageService: StateStorageService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
        // Disable open popup on first time access URL
        if (!Window['currentUrl'] && !Window['popupNavigated'] && (state.url.split('(').length || state.url.split('?').length)) {
            Window['popupNavigated'] = true;

            // Note case ?page= so we also need slit character ?
            this.router.navigate([state.url.split('(')[0].split('?')[0], { outlets: {
                popup: null,
                notification: null,
            }}], {
                replaceUrl: true
            });

            return false;
        }

        // Check authority
        const authorities = route.data['authorities'];
        if (!authorities || authorities.length === 0) {
            return true;
        }

        return this.checkLoginWithoutAnyAuthorities(state.url);
    }

    checkLoginWithoutAnyAuthorities(url: string): Promise<boolean> {
        const principal = this.principal;
        return Promise.resolve(principal.identity().then((account) => {
            if (account) {
                return true;
            }

            this.stateStorageService.storeUrl(url);
            this.router.navigate(['/login', { outlets: {
                popup: null,
                notification: null,
            }}]);

            return false;
        }));
    }

    checkLogin(authorities: string[], url: string): Promise<boolean> {
        const principal = this.principal;
        return Promise.resolve(principal.identity().then((account) => {

            if (account && principal.hasAnyAuthorityDirect(authorities)) {
                return true;
            }

            this.stateStorageService.storeUrl(url);
            this.router.navigate(['/login', { outlets: {
                popup: null,
                notification: null,
            }}]);

            return false;
        }));
    }
}
